import { useQuery } from "@tanstack/react-query";
import { reviewerApi, apiBaseConfigured, type CaseReview } from "@/lib/api";

export interface UseCaseReviewResult {
  data: CaseReview | null;
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useCaseReview(inquiryId: string | null | undefined): UseCaseReviewResult {
  const enabled = apiBaseConfigured() && !!inquiryId;

  const query = useQuery({
    queryKey: ["reviewer", "case-review", inquiryId],
    queryFn: () => reviewerApi.getCaseReview(inquiryId!),
    enabled,
    retry: 1,
    staleTime: 30_000,
    // Keep stale data visible across remounts so revisiting an applicant
    // renders the previous review instantly while a background refetch runs.
    placeholderData: (prev) => prev,
  });


  return {
    data: query.data ?? null,
    loading: enabled && query.isLoading,
    error: (query.error as Error) ?? null,
    refetch: () => query.refetch(),
  };
}
